/* Update width of mission and day containers */
/* TODO: Update position also */

window.widths = {
    mission: 0,
    day: 0
};

function updateMissionAndDayWidth() {
    widths.mission = $('.mission-container').first().outerWidth();
    widths.day = $('.day-container').first().outerWidth();
}

function resizeLoading() {
    var headerHeight = 0;

    if ($(window).width() < 1366) {
        headerHeight = $('.header-mobile').outerHeight();
    } else {
        headerHeight =
            $('.header-info').outerHeight() + $('.header-menu').outerHeight();
    }
    
    if ($('body').height() < $(window).height()) {
        $('#loading-container').height(
            $(window).height() -
            headerHeight -
            parseInt($('#booking-container').css('padding-top')) -
            parseInt($('#booking-container').css('padding-bottom')) -
            $('.footer').outerHeight()
        );
    }
}

function handleResize() {
    updateMissionAndDayWidth();

    resizeLoading();
}

$(window).resize(handleResize);

$(function() {
    handleResize();
});

/* Reactive mission and date-time selection */

new Vue({
    el: '#booking-container',

    data: {
        loading: true,
        missions: null,
        selectedMission: oldMissionNum,
        selectedDay: oldDayNum,
        userSelectedDay: oldDayNum,
        selectedTime: {
            hour: oldTime.length == 5 ? oldTime.substr(0, 2) : '',
            minute: oldTime.length == 5 ? oldTime.substr(3, 2) : ''
        },
        bookingStep: errors.length > 0 ? 1 : 0,
        voucher: oldVoucher,
        calculatingPrice: false,
        players: oldPlayers,
        invoice: oldInvoice,
        terms: oldTerms,
        highlightTerms: false,
        newsletter: oldNewsletter,
        errors: errors,
        widths: widths,
        finishBookingButton: window.translation.finishBookingButton,
        translation: window.translation
    },

    mounted() {
        var vm = this;

        axios.get(
            timesURL
        ).then(
            function (response) {
                if (typeof response['data'] != 'object') {
                    vm.bookingStep = 2;
                } else {
                    vm.missions = response['data'];
                    vm.initSelectedMission();
                    if (vm.bookingStep == 1) {
                        vm.calculatingPrice = true;
                        vm.getPrice();
                    }
                }

                $('#loading-container').css('height', '');

                vm.loading = false;

                vm.adjustSelectedDay();
            }
        ).catch(
            function () {
                vm.bookingStep = 2;
            }
        );
    },

    updated() {
        updateMissionAndDayWidth();
    },

    computed: {
        bookableDaysCount: function () {
            if (
                this.loading == false &&
                typeof this.missions[this.selectedMission].time_table ==
                'object' &&
                Array.isArray(
                    this.missions[this.selectedMission].time_table.days
                )
            ) {
                return (
                    this.missions[this.selectedMission].time_table.days.length
                );
            } else {
                return 0;
            }
        },

        missionPosition: function () {
            return this.selectedMission * this.widths.mission * (-1);
        },

        dayPosition: function () {
            return this.selectedDay * this.widths.day * (-1);
        },

        bookingEnabled: function() {
            let enabled = false;

            if (
                this.loading == false &&
                typeof this.missions[this.selectedMission].time_table ==
                'object' &&
                this.missions[this.selectedMission].time_table != null &&
                Array.isArray(
                    this.missions[this.selectedMission].time_table.days
                )
            ) {
                enabled =
                    this
                        .missions[this.selectedMission]
                        .time_table
                        .days[this.selectedDay]
                        .slots
                        .some(slot => {
                            return (
                                slot.time.hour == this.selectedTime.hour &&
                                slot.time.minute == this.selectedTime.minute &&
                                slot.available == true
                            );
                        })
                    ;
                ;
            }

            return enabled;
        },

        selectedDateTime: function () {
            if (
                this.loading == false &&
                typeof this.missions[this.selectedMission].time_table ==
                'object' &&
                Array.isArray(
                    this.missions[this.selectedMission].time_table.days
                )
            ) {
                return (
                    this
                    .missions[this.selectedMission]
                    .time_table
                    .days[this.selectedDay]
                    .canonical_date +
                    ' ' +
                    this.selectedTimeString
                );
            } else {
                return '';
            }
        },

        selectedTimeString: function () {
            return this.selectedTime.hour + ':' + this.selectedTime.minute;
        },

        price: function () {
            if (this.loading == true) {
                return 0;
            } else if (this.calculatingPrice) {
                return '...';
            } else {
                if (this.missions[this.selectedMission].slug == 'battle') {
                    return Math.min(
                        this.basePrice * 2,
                        this.priceWithCoupon
                    );
                } else {
                    return Math.min(
                        this.basePrice,
                        this.priceWithCoupon
                    );
                }
            }
        }
    },

    watch: {
        bookingStep: function () {
            window.scrollTo(0, 0);
        },

        voucher: function () {
            if (bookingStep == 0) {
                this.calculatingPrice = true;
                this.getPrice();
            }
        }
    },

    methods: {
        initSelectedMission() {
            var selectedMissionInit = 0;

            if (oldMissionNum) {
                selectedMissionInit = oldMissionNum;
            } else if (missionInURL) {
                selectedMissionInit = this.missions.findIndex(mission => {
                    return mission.id == missionInURL;
                });

                this.selectedMission =
                    (selectedMissionInit >= 0) ? selectedMissionInit : 0;
            }
        },

        selectNextMission() {
            if (Object.keys(this.missions).length > this.selectedMission + 1) {
                this.selectedMission++;
            }

            this.adjustSelectedDay();
        },

        selectPrevMission() {
            if (this.selectedMission > 0) {
                this.selectedMission--;
            }

            this.adjustSelectedDay();
        },

        selectNextDay() {
            if (this.selectedDay + 1 < this.bookableDaysCount) {
                this.selectedDay++;
            }

            this.userSelectedDay = this.selectedDay;
        },

        selectPrevDay() {
            if (this.selectedDay > 0) {
                this.selectedDay--;
            }

            this.userSelectedDay = this.selectedDay;
        },

        selectTimeSlot(hour, minute) {
            this.selectedTime.hour = hour;
            this.selectedTime.minute = minute;
        },

        nextBookingStep() {
            if (this.bookingEnabled) {
                this.bookingStep++;
                this.calculatingPrice = true;
                this.getPrice();
            }
        },

        prevBookingStep() {
            this.bookingStep--;
        },

        getPrice: _.debounce(
            function () {
                var vm = this;

                axios.get(
                    priceURL,
                    {
                        params: {
                            mission: this.selectedMission,
                            voucher: this.voucher,
                            days_time:
                                [
                                    this.selectedDay,
                                    this.selectedTime.hour,
                                    this.selectedTime.minute
                                ]
                                .join(':')
                        }
                    }
                ).then(
                    function (response) {
                        if (Array.isArray(response.data.options)) {
                            var missionWithUpdatedOptions = vm.missions[vm.selectedMission];
                            missionWithUpdatedOptions.options = response.data.options;
                            vm.missions.splice(vm.selectedMission, 1, missionWithUpdatedOptions);
                        }
                            
                        vm.calculatingPrice = false;
                    }
                )
            },
            2000
        ),

        processReservation(e) {
            if (!this.terms) {
                e.preventDefault();
                this.highlightTerms = true;
            } else {
                this.finishBookingButton = '<i class="fa fa-spinner fa-pulse fa-fw"></i>';
            }
        },

        showDisclosurePopup() {
            $('.popup-container[data-popup="disclosure"]').show();
        },

        showPrivacyPolicyPopup() {
            $('.popup-container[data-popup="privacy-policy"]').show();
        },

        adjustSelectedDay() {
            let days_till_opening = 0;

            if (
                typeof this.missions[this.selectedMission].opens_on == 'string' &&
                this.missions[this.selectedMission].opens_on.length > 0
            ) {
                let opening_day = moment(this.missions[this.selectedMission].opens_on);
                let today = moment().startOf('day');
                days_till_opening = opening_day.diff(today, 'days');
            }

            this.selectedDay = Math.max(days_till_opening, this.userSelectedDay);
        }
    }
});
